import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiFlatButton from 'material-ui/FlatButton';
import { white54 } from '../../../theme/colors';
import './settings-skip.css';

export default class SettingsSkip extends Component {
  static get propTypes() {
    return {
      hideSkip: PropTypes.bool,
      moveForward: PropTypes.func.isRequired
    };
  }

  render() {
    if (this.props.hideSkip) return null;

    return (
      <div className="settings-skip">
        <MuiFlatButton
          label="Skip"
          labelStyle={{ color: white54 }}
          style={{ fontSize: '1.4rem' }}
          hoverColor="transparent"
          rippleColor="transparent"
          onClick={ this.props.moveForward }
        />
      </div>
    );
  }
}
